import FontFaceObserver from "fontfaceobserver";
import imagesLoaded from "imagesloaded";
var THREE = require('three');
import Scene from "./scene";
const TWEEN = require("tween");
import {
	STEPS,
	CREDITS,
	AUDIO_CUES,
	CLOSE_EYES_1,
	CLOSE_EYES_2,
	VOICE,
	TIMINGS
} from "./story";


let canvas;
let audio = new Audio();
let ctx;
let radius = document.body.clientWidth <= 425 ? 120 : 160;
let steps = document.body.clientWidth <= 425 ? 60 : 120;
let pointsUp = [];
let pointsDown = [];
let pCircle = 2 * Math.PI * radius;
let angleExtra = 90;
let closeEyes1;
let closeEyes2;
const scene = new Scene();
let currentStep = 0;

let audioIsPlaying = false;
let centerX;
let centerY;
var moving = false;

let introIsOn = true;
let IMAGES;


// helper functions
const MathUtils = {
    // map number x from range [a, b] to [c, d]
    map: (x, a, b, c, d) => ((x - a) * (d - c)) / (b - a) + c,
    // linear interpolation
    lerp: (a, b, n) => (1 - n) * a + n * b
};
const getPageYScroll = () => (docScroll = window.pageYOffset || document.documentElement.scrollTop);
// calculate the viewport size
let winsize;
const calcWinsize = () => (winsize = {width: window.innerWidth, height: window.innerHeight});
calcWinsize();
// and recalculate on resize
window.addEventListener("resize", calcWinsize);

window.onbeforeunload = function ()
{
    window.scrollTo(0, 0);
};
let dataText = ["Incoming Transmission", "Please ensure your headphones are on securely.", "Click to receive transmission"];
let initStep = 0;
// scroll position and update function
let docScroll;
let videoIntro = document.getElementById('myVideoIntro');
videoIntro.preload = 'auto';
videoIntro.loop = true;
videoIntro.autoplay = true;
let texture = new THREE.VideoTexture(videoIntro);
videoIntro.load();
videoIntro.play();
texture.minFilter = THREE.LinearFilter;
texture.magFilter = THREE.LinearFilter;
texture.needsUpdate = true;
scene.scene.background = texture;

let openAudio = document.getElementById("openLoop");
let audio1 = document.getElementById("myAudio1");
let audio2 = document.getElementById("myAudio2");
let running = false;
let thisTweenTimer = TIMINGS.thisTweenTimer;
let titleTimer = TIMINGS.titleTimer;
let fadeTimerTrans = TIMINGS.fadeTimerTrans;
let letterTimer = TIMINGS.letterTimer;
let sentenceTimer = TIMINGS.sentenceTimer;
// -------------
// Audio stuff
// -------------
// make a Web Audio Context
let context = new AudioContext();
const splitter = context.createChannelSplitter();
const analyserL = context.createAnalyser();
analyserL.fftSize = 8192;
const analyserR = context.createAnalyser();
analyserR.fftSize = 8192;
splitter.connect(analyserL, 0, 0);
splitter.connect(analyserR, 1, 0);

// Make a buffer to receive the audio data
const bufferLengthL = analyserL.frequencyBinCount;
const audioDataArrayL = new Uint8Array(bufferLengthL);

const bufferLengthR = analyserR.frequencyBinCount;
const audioDataArrayR = new Uint8Array(bufferLengthR);
let mainAudioPlaying = false;
let rollCredits = false;
let visualiserActive = false;
let activeVideo = videoIntro;

// Make a audio node


function loadAudio()
{
    console.log("loaded audio");
    audio.loop = false;
    audio.autoplay = false;
    audio.crossOrigin = "anonymous";
    // call `handleCanplay` when it music can be played
    if (!mainAudioPlaying)
    {

    }
    audio.addEventListener('canplay', handleCanplay);
    audio.load();
    running = true;
}


function handleCanplay()
{
    // connect the audio element to the analyser node and the analyser node
    // to the main Web Audio context

    const source = context.createMediaElementSource(audio);
    source.connect(splitter);
    splitter.connect(context.destination);
}


function toggleAudio()
{
    if (running === false)
    {
        loadAudio();
    }

    if (audio.paused)
    {
        audio.play();
    }
    // else
    // {
    //     audio.pause();
    // }
}


function drawLine(points)
{
    let origin = points[0];

    ctx.beginPath();
    ctx.strokeStyle = 'rgba(0.0,255,0.0,1.0)';
    ctx.lineJoin = 'round';
    ctx.moveTo(origin.x, origin.y);
    for (let i = 0; i < points.length; i++)
    {
        ctx.lineTo(points[i].x, points[i].y);
    }

    ctx.lineTo(origin.x, origin.y);
    ctx.stroke();
}

function connectPoints(pointsA, pointsB)
{
    for (let i = 0; i < pointsA.length; i++)
    {
        ctx.beginPath();
        ctx.strokeStyle = 'rgba(0.0,255,0.0,1.0)';
        ctx.moveTo(pointsA[i].x, pointsA[i].y);
        ctx.lineTo(pointsB[i].x, pointsB[i].y);
        ctx.stroke();
    }
}

function update(dt)
{
    let audioIndex, audioValue;

    // get the current audio data
    analyserL.getByteFrequencyData(audioDataArrayL);
    analyserR.getByteFrequencyData(audioDataArrayR);

    for (let i = 0; i < pointsUp.length; i++)
    {
        audioIndex = Math.ceil(pointsUp[i].angle * (bufferLengthL / (pCircle * 2))) | 0;
        // get the audio data and make it go from 0 to 1
        audioValue = audioDataArrayL[audioIndex] / 255;

        pointsUp[i].dist = 1.1 + audioValue * 0.8;
        pointsUp[i].x = centerX + radius * Math.cos(-pointsUp[i].angle * Math.PI / 180) * pointsUp[i].dist;
        pointsUp[i].y = centerY + radius * Math.sin(-pointsUp[i].angle * Math.PI / 180) * pointsUp[i].dist;

        audioIndex = Math.ceil(pointsDown[i].angle * (bufferLengthR / (pCircle * 2))) | 0;
        // get the audio data and make it go from 0 to 1
        audioValue = audioDataArrayR[audioIndex] / 255;

        pointsDown[i].dist = 0.9 + audioValue * 0.2;
        pointsDown[i].x = centerX + radius * Math.cos(-pointsDown[i].angle * Math.PI / 180) * pointsDown[i].dist;
        pointsDown[i].y = centerY + radius * Math.sin(-pointsDown[i].angle * Math.PI / 180) * pointsDown[i].dist;
    }
}

function updateVideoTexture(step)
{
    if (activeVideo)
    {
        activeVideo.pause();
        activeVideo.loop = false;
    }
    const videoIds = ['myVideo2', 'myVideo3', 'myVideo4', 'myVideo5'];
    const newVideo = document.getElementById(videoIds[step - 1]);
    newVideo.preload = 'auto';
    newVideo.loop = true;
    newVideo.autoplay = true;
    newVideo.crossOrigin = "anonymous";
    newVideo.play();
    activeVideo = newVideo;
    if (texture != null)
    {
        texture.dispose();
    }
    texture = new THREE.VideoTexture(newVideo);
    texture.minFilter = THREE.LinearFilter;
    texture.magFilter = THREE.LinearFilter;
    texture.needsUpdate = true;
    scene.scene.background = texture;
}

function draw()
{
    if (canvas && ctx)
    {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        drawLine(pointsUp);
        drawLine(pointsDown);
        connectPoints(pointsUp, pointsDown);
    }
}

function checkAudioCues(smoothScroll)
{
    if (!audioIsPlaying || !audio) return;
    const t = audio.currentTime;
    const selected = localStorage.getItem("selected");
    if (!selected) return;

    const cue = AUDIO_CUES[selected];
    if (!cue) return;

    if (!closeEyes1 && t > cue.closeEyes)
    {
        closeEyes1 = true;
        dataText = selected === '1' ? CLOSE_EYES_1 : CLOSE_EYES_2;
        smoothScroll.StartTextAnimation(0);
        $('canvas').fadeOut(3000 * Math.random(), function ()
        {
            $('canvas').fadeIn(3000 * Math.random(), function ()
            {
                $('canvas').fadeOut(3000 * Math.random(), function ()
                {
                    $('canvas').fadeIn(3000 * Math.random(), function ()
                    {
                        $('canvas').fadeOut(3000 * Math.random(), function ()
                        {
                            $('h1').fadeOut(3000 * Math.random(), function ()
                            {
                                $('h1').fadeIn(3000 * Math.random(), function ()
                                {
                                    $('h1').fadeOut(3000 * Math.random(), function ()
                                    {
                                        $('h1').fadeIn(3000 * Math.random(), function ()
                                        {
                                            $('h1').fadeOut(3000 * Math.random(), function ()
                                            {
                                            });
                                        });
                                    });
                                });
                            });
                        });
                    });
                });
            });
        });
    }

    if (!rollCredits && t > cue.credits)
    {
        rollCredits = true;
        dataText = CREDITS;
        smoothScroll.StartTextAnimation(0);
        sentenceTimer = 3000;
        $('h1').fadeIn(1500, function () {});
    }
}

// Item
class Item
{
    constructor(el)
    {
        this.DOM = {el: el.img};
        this.animated = false;
        this.isBeingAnimatedNow = false;

        this.shouldUnRoll = false;


        this.getSize();
        this.mesh = scene.createMesh({
            width: this.width,
            height: this.height,
            depth: this.depth,
            src: this.src,
            image: this.DOM.el,
            iWidth: this.DOM.el.width,
            iHeight: this.DOM.el.height,
        });
        if (initStep === 5)
        {
            this.mesh.position.z = (initStep + 1) * -60;
            this.mesh.position.x -= 650;
            this.mesh.name = "meshLeft";
            scene.domEvents.addEventListener(this.mesh, 'mouseover', function ()
            {
                this.scale.x = 1.2;
                this.scale.y = 1.2;
            });
            scene.domEvents.addEventListener(this.mesh, 'mouseout', function ()
            {
                this.scale.x = 1;
                this.scale.y = 1;
            });
        }
        else if (initStep === 6)
        {
            this.mesh.position.z = (initStep) * -60;
            this.mesh.position.x += 650;
            this.mesh.name = "meshRight";
            scene.domEvents.addEventListener(this.mesh, 'mouseover', function ()
            {
                this.scale.x = 1.2;
                this.scale.y = 1.2;
            });
            scene.domEvents.addEventListener(this.mesh, 'mouseout', function ()
            {
                this.scale.x = 1;
                this.scale.y = 1;
            });
        }
        else if (initStep < 5)
        {
            if (initStep % 2 === 0)
            {
                this.mesh.position.z = (initStep + 1) * -50;
                this.mesh.position.x -= Math.random() * 200;
                this.mesh.position.y += Math.random() * 50;
            }
            else
            {
                this.mesh.position.z = (initStep + 1) * -50;
                this.mesh.position.x += Math.random() * 200;
                this.mesh.position.y -= Math.random() * 50;
            }
        }
        else if (initStep > 6)
        {
            if (initStep % 2 === 0)
            {
                this.mesh.position.z = initStep * -50;
                this.mesh.position.x -= Math.random() * 200;
                this.mesh.position.y += Math.random() * 50;
            }
            else
            {
                this.mesh.position.z = initStep * -50;
                this.mesh.position.x += Math.random() * 200;
                this.mesh.position.y -= Math.random() * 50;
            }
        }
        initStep++;
        scene.scene.add(this.mesh);
        window.addEventListener("resize", () => this.resize());


    }

    resize()
    {
        this.getSize();
        this.mesh.scale.set(this.width, this.height, 200);

    }

    getSize()
    {
        // get all the sizes here, bounds and all
        const bounds = this.DOM.el.getBoundingClientRect();
        const fromTop = bounds.top;
        const windowHeight = window.innerHeight;
        const withoutHeight = fromTop - windowHeight;
        const withHeight = fromTop + bounds.height;
        this.insideTop = withoutHeight - docScroll;
        this.insideRealTop = fromTop + docScroll;
        this.insideBottom = withHeight - docScroll + 50;
        this.width = bounds.width;
        this.height = bounds.height;
        this.left = bounds.left;
    }


}

/***********************************/
/********** Preload stuff **********/

const fontParalucent = new FontFaceObserver("laca-text").load();
const fontStarling = new FontFaceObserver("operetta-12").load();

// Preload images
const preloadImages = new Promise((resolve, reject) =>
{
    imagesLoaded(document.querySelectorAll("img"), {background: true}, resolve);
});


preloadImages.then(images =>
{
    IMAGES = images.images;
});

const preloadEverything = [fontStarling, fontParalucent, preloadImages, videoIntro, audio1, audio2, openAudio, context];

// And then...
Promise.all(preloadEverything).then(() =>
{
    openAudio.loop = true;
    openAudio.autoplay = true;
    openAudio.crossOrigin = "anonymous";
    openAudio.load();

    // videoIntro.play().then(r =>
    // {
    //     console.log("played")
    // });
    getPageYScroll();
    new SmoothScroll();
    document.body.classList.remove("loading");
    document.body.classList.add("loaded");

    $(".header__title").fadeIn(titleTimer * 2, function ()
    {
        $("#info1").fadeIn(titleTimer, function ()
        {
            $("#info2").fadeIn(titleTimer, function ()
            {
                $("#info3").fadeIn(titleTimer, function ()
                {
                    $("#info4").fadeIn(titleTimer, function ()
                    {
                        $("#controlsInfo").fadeIn(titleTimer / 3, function ()
                        {

                            introIsOn = false;
                        });
                    });
                });
            });
        });
    });
}).catch(console.log);

// SmoothScroll
class SmoothScroll
{
    constructor()
    {

        this.shouldRender = false;
        this.DOM = {main: document.querySelector("main")};
        // the scrollable element
        // we translate this element when scrolling (y-axis)
        this.DOM.scrollable = this.DOM.main.querySelector("div[data-scroll]");
        // the items on the page
        this.items = [];
        this.createItems();
        //this.createVideos();
        this.listenMouse();
        window.addEventListener("click", () => this.clicked());
        // here we define which property will change as we scroll the page
        // in this case we will be translating on the y-axis
        // we interpolate between the previous and current value to achieve the smooth scrolling effect
        this.renderedStyles = {
            translationY: {
                // interpolated value
                previous: 0,
                // current value
                current: 0,
                // amount to interpolate
                ease: 0.1,
                // current value setter
                // in this case the value of the translation will be the same like the document scroll
                setValue: () => docScroll
            }
        };
        // set the body's height
        //this.setSize();
        // set the initial values
        //this.update();
        // the <main> element's style needs to be modified
        this.style();
        // init/bind events
        //this.initEvents();
        // start the render loop

        requestAnimationFrame(this.render.bind(this));

    }

    startCameraTransition(distance)
    {

        const coords = {x: scene.camera.position.x, y: scene.camera.position.y, z: scene.camera.position.z};
        let desiredZpos = coords.z - distance;
        const tween = new TWEEN.Tween(coords).to({x: coords.x, y: coords.y, z: desiredZpos}, thisTweenTimer).easing(TWEEN.Easing.Quadratic.InOut).onUpdate(() =>
        {
            scene.camera.position.z = coords.z;
        }).onComplete(() =>
        {

        }).start();
    }

    startCameraTransitionDecision(distance, selection)
    {
        $('buttonl').remove();
        $('buttonr').remove();
        const coords = {x: scene.camera.position.x, y: scene.camera.position.y, z: scene.camera.position.z, w: 0};
        let desiredXMovement = 0;
        if (selection === 1)
        {
            desiredXMovement = -700;
        }
        else if (selection === 2)
        {
            desiredXMovement = 700;
        }
        let desiredZpos = coords.z - distance;
        const tween = new TWEEN.Tween(coords).to({x: desiredXMovement, y: coords.y, z: desiredZpos, w: 1}, thisTweenTimer).easing(TWEEN.Easing.Quadratic.InOut).onUpdate(() =>
        {
            document.getElementById("overlay").style.opacity = coords.w;
            scene.camera.position.z = coords.z;
            scene.camera.position.x = coords.x;
        }).onComplete(() =>
        {

            $('canvas').remove();
            scene.background = null;
            this.StartTextAnimation(0);
            moving = true;
            scene.disposeEverything();
            openAudio.remove();
        }).start();
    }

    fadeOverlay()
    {
        const coords = {x: scene.camera.position.x, y: scene.camera.position.y, z: scene.camera.position.z, w: 0};
        const tween = new TWEEN.Tween(coords).to({x: coords.x, y: coords.y, z: coords.y, w: 0}, 1500).easing(TWEEN.Easing.Quadratic.InOut).onUpdate(() =>
        {
            document.getElementById("overlay").style.opacity = coords.w;
        }).onComplete(() =>
        {
            document.getElementById("overlay").remove();
        }).start();
    }

    typeWriter(text, i, fnCallback)
    {
        var that = this;
        // chekc if text isn't finished yet
        if (i < (text.length))
        {
            // add next character to h1
            document.querySelector("h1").innerHTML = text.substring(0, i + 1) + '<span aria-hidden="true"></span>';
            // wait for a while and call this function again for next character
            setTimeout(function ()
            {
                that.typeWriter(text, i + 1, fnCallback)
            }, letterTimer);
        }
        // text finished, call callback if there is a callback function
        else if (typeof fnCallback == 'function')
        {
            // call callback after timeout
            setTimeout(fnCallback, sentenceTimer);
        }
    }

    StartTextAnimation(i)
    {
        var that = this;
        if (typeof dataText[i] == 'undefined')
        {
            setTimeout(function ()
            {
                currentStep++;
                moving = false;
                if (rollCredits)
                {
                    that.StartTextAnimation(0);
                }
                // TO START AGAIN

            }, 1);
            return;
        }
        // check if dataText[i] exists

        if (i < dataText[i].length)
        {
            // text exists! start typewriter animation
            that.typeWriter(dataText[i], 0, function ()
            {
                // after callback (and whole text has been animated), start next text
                that.StartTextAnimation(i + 1);
            });
        }

    }

    attachEvent(elem, event, func)
    {
        if (elem.attachEvent)
        {
            elem.attachEvent("on" + event, func);
        }
        else
        {
            elem.addEventListener(event, func);
        }
    }


    clicked()
    {
        if (introIsOn || audioIsPlaying || moving) return;

        const step = STEPS[currentStep];
        if (!step) return;

        switch (currentStep)
        {
            case 0:
                this.enterStep0(step);
                break;
            case 1:
            case 2:
            case 3:
                this.enterStepImage(step);
                break;
            case 4:
                this.enterStepChoice(step);
                break;
            case 5:
                this.enterStepVisualiser(step);
                break;
        }
    }

    enterStep0(step)
    {
        openAudio.play();
        context.resume();
        moving = true;
        this.fadeOutAllTexts(() =>
        {
            this.applyStepTexts(step, { italics: false });
            this.fadeInStepTexts(step, () =>
            {
                moving = false;
                currentStep++;
            });
        });
        this.startCameraTransition(step.cameraDistance);
        this.startTransitionEffect();
    }

    enterStepImage(step)
    {
        moving = true;
        this.fadeOutAllTexts(() =>
        {
            if (step.videoStep > 0) updateVideoTexture(step.videoStep);
            const italics = currentStep >= 3 && currentStep <= 4;
            this.applyStepTexts(step, { italics });
            this.fadeInStepTexts(step, () =>
            {
                moving = false;
                currentStep++;
            });
        });
        this.startCameraTransition(step.cameraDistance);
        this.startTransitionEffect();
    }

    enterStepChoice(step)
    {
        var that = this;
        moving = true;
        this.fadeOutAllTexts(() =>
        {
            if (step.videoStep > 0) updateVideoTexture(step.videoStep);
            this.applyStepTexts(step, { italics: false });
            this.fadeInStepTexts(step, () =>
            {
                $("#female").fadeIn(fadeTimerTrans, function ()
                {
                });
                $("#male").fadeIn(fadeTimerTrans, function ()
                {
                    var buttonl = document.createElement("buttonl");
                    var body = document.getElementsByTagName("body")[0];
                    body.appendChild(buttonl);
                    buttonl.addEventListener("click", function ()
                    {
                        localStorage.setItem("selected", String(VOICE.MALE));
                        audio = audio1;
                        loadAudio();
                        that.onVoiceSelected(VOICE.MALE);
                    });

                    var buttonr = document.createElement("buttonr");
                    body.appendChild(buttonr);
                    buttonr.addEventListener("click", function ()
                    {
                        localStorage.setItem("selected", String(VOICE.FEMALE));
                        audio = audio2;
                        loadAudio();
                        that.onVoiceSelected(VOICE.FEMALE);
                    });
                });
            });
        });
        this.startCameraTransition(step.cameraDistance);
        this.startTransitionEffect();
    }

    onVoiceSelected(selection)
    {
        document.getElementById("info1").innerHTML = "";
        document.getElementById("info2").innerHTML = "";
        document.getElementById("info3").innerHTML = "";
        document.getElementById("info4").innerHTML = "";
        document.getElementById("info5").innerHTML = "";
        $("#female").fadeOut(500, function ()
        {
        });
        $("#male").fadeOut(500, function ()
        {
            $("#female").remove();
            $("#male").remove();
        });
        this.startCameraTransitionDecision(80, selection);
        this.startTransitionEffect();
    }

    enterStepVisualiser(step)
    {
        toggleAudio();
        canvas = document.createElement("canvas");
        canvas.style.opacity = 1;
        canvas.style.zIndex = 1001;
        document.getElementById("datascroll").remove();
        document.getElementById("container").appendChild(canvas);

        ctx = canvas.getContext("2d");
        canvas.width = window.innerWidth;
        canvas.height = window.innerHeight;
        window.addEventListener('resize', function onCanvasResize()
        {
            canvas.width = window.innerWidth;
            canvas.height = window.innerHeight;
            centerX = canvas.width / 2;
            centerY = canvas.height / 2;
        });

        centerX = canvas.width / 2;
        centerY = canvas.height / 2;

        let interval = 360 / steps;
        for (let angle = 0; angle < 360; angle += interval)
        {
            let distUp = 1.1;
            let distDown = 0.9;

            pointsUp.push({
                angle: angle + angleExtra,
                x: centerX + radius * Math.cos((-angle + angleExtra) * Math.PI / 180) * distUp,
                y: centerY + radius * Math.sin((-angle + angleExtra) * Math.PI / 180) * distUp,
                dist: distUp
            });

            pointsDown.push({
                angle: angle + angleExtra + 5,
                x: centerX + radius * Math.cos((-angle + angleExtra + 5) * Math.PI / 180) * distDown,
                y: centerY + radius * Math.sin((-angle + angleExtra + 5) * Math.PI / 180) * distDown,
                dist: distDown
            });
        }

        dataText = step.info;
        this.StartTextAnimation(0);
        audioIsPlaying = true;
        visualiserActive = true;
        currentStep++;
    }

    fadeOutAllTexts(callback)
    {
        const t = fadeTimerTrans / 4;
        $("#controlsInfo").fadeOut(t, function ()
        {
            $("#info5").fadeOut(t, function ()
            {
                $("#info4").fadeOut(t, function ()
                {
                    $("#info3").fadeOut(t, function ()
                    {
                        $("#info2").fadeOut(t, function ()
                        {
                            $("#info1").fadeOut(t, function ()
                            {
                                $("#header_title").fadeOut(t, callback);
                            });
                        });
                    });
                });
            });
        });
    }

    applyStepTexts(step, { italics })
    {
        const fmt = italics ? (s) => s.italics() : (s) => s;
        for (let i = 0; i < 5; i++)
        {
            document.getElementById("info" + (i + 1)).innerHTML = fmt(step.info[i] || "");
        }
        if (step.controlsInfo)
        {
            document.getElementById("controlsInfo").innerHTML = step.controlsInfo;
        }
    }

    fadeInStepTexts(step, callback)
    {
        const t = fadeTimerTrans;
        $("#info1").fadeIn(t, function ()
        {
            $("#info2").fadeIn(t, function ()
            {
                $("#info3").fadeIn(t, function ()
                {
                    $("#info4").fadeIn(t, function ()
                    {
                        $("#info5").fadeIn(t, function ()
                        {
                            $("#controlsInfo").fadeIn(t / 3, callback);
                        });
                    });
                });
            });
        });
    }



    startTransitionEffect()
    {

        let effectValue = {x: 10000};
        let halfwayValue = effectValue.x / 2;
        let tweenEffect = new TWEEN.Tween(effectValue).to({x: 0}, thisTweenTimer).easing(TWEEN.Easing.Quadratic.InOut).onUpdate(() =>
        {
            this.createTransitionEffect(halfwayValue, effectValue.x);
        }).onComplete(() =>
        {
            scene.distortValue = 0.1;
        }).start();
    }

    createTransitionEffect(halfwayPoint, currValue)
    {
        if (currValue > halfwayPoint)
        {
            scene.distortValue += 0.02;
        }
        else
        {
            scene.distortValue -= 0.02;
        }
    }


    listenMouse()
    {
        document.addEventListener('mousemove', () =>
        {
            this.shouldRender = true;
        })
    }

    setPosition()
    {
        // translates the scrollable element
        if (Math.round(this.renderedStyles.translationY.previous) !== Math.round(this.renderedStyles.translationY.current) || this.renderedStyles.translationY.previous < 10)
        {
            this.shouldRender = true;
            this.DOM.scrollable.style.transform = `translate3d(0,${-1 * this.renderedStyles.translationY.previous}px,0)`;
            for (const item of this.items)
            {
                // if the item is inside the viewport call it's render function
                // this will update the item's inner image translation, based on the document scroll value and the item's position on the viewport
                if (item.isVisible || item.isBeingAnimatedNow)
                {
                    item.render(this.renderedStyles.translationY.previous);
                }
            }
        }
        if (scene.targetSpeed > 0.01)
        {
            this.shouldRender = true;
        }
        if (this.shouldRender)
        {
            this.shouldRender = false;
            scene.render();
        }
    }

    createItems()
    {
        IMAGES.forEach(image =>
        {
            if (image.img.classList.contains("js-image"))
            {
                this.items.push(new Item(image, this));
            }
        });
    }

// createVideos()
// {
//     VIDEOS.forEach(video =>
//     {
//         if (video.video.classList.contains("myVideo"))
//         {
//             this.videos.push(new MyVideo(video, this));
//         }
//     });
// }

    style()
    {
        // the <main> needs to "stick" to the screen and not scroll
        // for that we set it to position fixed and overflow hidden
        this.DOM.main.style.position = "fixed";
        this.DOM.main.style.width = this.DOM.main.style.height = "100%";
        this.DOM.main.style.top = this.DOM.main.style.left = 0;
        this.DOM.main.style.overflow = "hidden";
    }

    render()
    {
        for (const key in this.renderedStyles)
        {
            this.renderedStyles[key].current = this.renderedStyles[key].setValue();
            this.renderedStyles[key].previous = MathUtils.lerp(
                this.renderedStyles[key].previous,
                this.renderedStyles[key].current,
                this.renderedStyles[key].ease
            );
        }
        this.setPosition();
        TWEEN.update();

        if (running)
        {
            update();
        }
        if (visualiserActive)
        {
            draw();
            checkAudioCues(this);
        }

        requestAnimationFrame(() => this.render());
    }
}





